import { memo } from 'react';
import { deepCompare } from '../utils';
import { ColumnData, DnDTable } from './DnDTable';

export interface DnDSubRowProps {
  columns: Array<ColumnData>;
  renderer?: (data: Record<string, any>) => React.ReactNode | JSX.Element;
  data: Array<Record<string, any>>;
  colspan: number;
}

const DnDSubRow: React.FC<DnDSubRowProps> = (props) => {
  const { data = [], colspan, columns = [], renderer } = props;

  return (
    <tr className="table-sub-row">
      <td className="drag-handle-td" />
      <td className="expand-button-td" />
      <td colSpan={colspan}>
        {typeof renderer === 'function' ? (
          renderer(data)
        ) : (
          <DnDTable
            expandable={false}
            rowSelection={false}
            columns={columns}
            data={data}
            noDataText={'-'}
            rowsPerPage={15}
            draggable={false}
          />
        )}
      </td>
    </tr>
  );
};

export default memo(DnDSubRow, deepCompare);
